import { render } from "./SaleableListTemplate.vue?vue&type=template&id=3def040d&scoped=true"
import script from "./SaleableListTemplate.vue?vue&type=script&lang=js"
export * from "./SaleableListTemplate.vue?vue&type=script&lang=js"

import "./SaleableListTemplate.vue?vue&type=style&index=0&id=3def040d&scoped=true&lang=css"

import exportComponent from "D:\\agents\\Oreo\\_work\\93\\s\\NcasReporting\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3def040d"]])

export default __exports__